module.exports = __webpack_public_path__ + "media/V27.c50a73db.mp4";